// src/components/User/Components/UserDataGridColumns.js
import React from "react";
import { Box } from "@mui/material";
import { CheckCircle, Cancel } from "@mui/icons-material";
import UserActionCell from "./UserActionCell";

export function getUserColumns(onEditUser) {
  const actionsColumn = {
    field: "actions",
    headerName: "Actions",
    width: 120,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <UserActionCell row={params.row} onEditUser={onEditUser} />
    ),
  };

  return [
    { field: "id", headerName: "ID", flex: 0.5, minWidth: 70 },
    { field: "fullName", headerName: "Fullname", flex: 1, minWidth: 150 },
    { field: "email", headerName: "Email Address", flex: 1.5, minWidth: 200 },
    { field: "role", headerName: "Role", flex: 1, minWidth: 120 },
    {
      field: "hasSeenTrainingVideo",
      headerName: "Training Completed",
      flex: 1,
      minWidth: 150,
      type: "boolean",
    },
    {
      field: "isActive",
      headerName: "Active",
      flex: 0.7,
      minWidth: 100,
      type: "boolean",
      renderCell: (params) => (
        <Box display="flex" alignItems="center" justifyContent="center">
          {params.value ? (
            <CheckCircle color="success" />
          ) : (
            <Cancel color="error" />
          )}
        </Box>
      ),
    },
    {
      ...actionsColumn,
      flex: 0.7,
      minWidth: 100,
    },
  ];
}
